export default __webpack_public_path__ + "static/media/White logo(Footer)-05 (1).0146bebc.png";